import showdown from 'showdown';

export function markdownToHtml(text) {
  let converter = new showdown.Converter({
    simplifiedAutoLink: true,
    simpleLineBreaks: true,
  });
  return converter.makeHtml(text);
}

export function genPassword(len = 10) {
  const chars = "234567892345678923456789bdefghijkmnqrstuvwxyzDEF";
  let password = "";
  for (let i = 0; i <= len; i++) {
    let randomNumber = Math.floor(Math.random() * chars.length);
    password += chars.substring(randomNumber, randomNumber +1);
  }
  return password;
}

export default {
  markdownToHtml,
  genPassword,
};
